        import React from 'react'
        import { useRef, useEffect, useState } from 'react';
        // import './bameio.css'
        import pic from './dropdown.png'
        import Loading from './Loading';
        const  text_list = [
        "Domineering",
        "Heroic",
        "Funny"
        ]; 

        function Bameio({selected, setSelected}) {

            // console.log();
            const options = [
                "Afrikaans",
                "Albanian",
                "Amharic",
                "Arabic",
                "Armenian",
                "Assamese",
                "Aymara",
                "Azerbaijani",
                "Bambara",
                "Basque",
                "Belarusian",
                "Bengali",
                "Bhojpuri",
                "Bosnian",
                "Bulgarian",
                "Catalan",
                "Cebuano",
                "Chichewa",
                "Simplified Chinese",
                "Traditional Chinese",
                "Corsican",
                "Croatian",
                "Czech",
                "Danish",
                "Dhivehi",
                "Dogri",
                "Dutch",
                "English",
                "Esperanto",
                "Estonian",
                "Ewe",
                "Filipino",
                "Finnish",
                "French",
                "Frisian",
                "Galician",
                "Georgian",
                "German",
                "Greek",
                "Guarani",
                "Gujarati",
                "Haitian Creole",
                "Hausa",
                "Hawaiian",
                "Hebrew",
                "Hindi",
                "Hmong",
                "Hungarian",
                "Icelandic",
                "Igbo",
                "Ilocano",
                "Indonesian",
                "Irish",
                "Italian",
                "Japanese",
                "Javanese",
                "Kannada",
                "Kazakh",
                "Khmer",
                "Kinyarwanda",
                "Konkani",
                "Korean",
                "Krio",
                "Kurmanji Kurdish",
                "Sorani Kurdish",
                "Kyrgyz",
                "Lao",
                "Latin",
                "Latvian",
                "Lingala",
                "Lithuanian",
                "Luganda",
                "Luxembourgish",
                "Macedonian",
                "Maithili",
                "Malagasy",
                "Malay",
                "Malayalam",
                "Maltese",
                "Maori",
                "Marathi",
                "Manipuri",
                "Mizo",
                "Mongolian",
                "Myanmar/Burmese",
                "Nepali",
                "Norwegian",
                "Odia/Oriya",
                "Oromo",
                "Pashto",
                "Persian",
                "Polish",
                "Portuguese",
                "Punjabi",
                "Quechua",
                "Romanian",
                "Russian",
                "Samoan",
                "Sanskrit",
                "Scots Gaelic",
                "Sepedi",
                "Serbian",
                "Sesotho",
                "Shona",
                "Sindhi",
                "Sinhala",
                "Slovak",
                "Slovenian",
                "Somali",
                "Spanish",
                "Sundanese",
                "Swahili",
                "Swedish",
                "Tajik",
                "Tamil",
                "Tatar",
                "Telugu",
                "Thai",
                "Tigrinya",
                "Tsonga",
                "Turkish",
                "Turkmen",
                "Twi",
                "Ukrainian",
                "Urdu",
                "Uyghur",
                "Uzbek",
                "Vietnamese",
                "Welsh",
                "Xhosa",
                "Yiddish",
                "Yoruba",
                "Zulu"
                ]
            
            const inputTag = useRef();
            // console.log(inputTag.current.value);

            // const searchTag = useRef();
            const optionss = useRef();

            const [isactive, setIsActive] = useState(false)
            // const [show, setShow] = useState(false)
            const [index, setIndex] = useState(0);
            const [subIndex, setSubIndex] = useState(0);
            const [blink, setBlink] = useState(true);
            const [reverse, setReverse] = useState(false);
            const [message, setMessage] = useState('');
            const [response, setResponse] =  useState('');
            const [isLoading, setLoading] = useState(false)

            // const [getResponses, SetgetResponses] = useState('');
            // const [value, setValue] = useState('');
            useEffect(() => {

                
                if( index === text_list.length - 1 && subIndex === text_list[index].length) {
                        return index === 0;
                } 
                if(
                    subIndex === text_list[index].length + 1 &&
                    index !== text_list.length -1 &&
                    !reverse
                ) {
                    setReverse(true);
                    return;
                }
                if(subIndex === 0 && reverse) {
                    setReverse(false);
                    setIndex((prev) => prev + 1);
                    return ;
                }
                const timeout = setInterval(() => {
                    setSubIndex((prev) => prev + (reverse ? -1 : 1));
                }, Math.max(reverse ? 75 : subIndex === text_list[index].length ? 1000 : 150, parseInt(Math.random() * 350)));
                return () => clearInterval(timeout)
                // return timeout;

            }, [subIndex, index, reverse])


            useEffect(() => {
        

                const timeout2 = setInterval(() => {
                    setBlink((prev) => !prev)
                }, 500); 
                return () => clearInterval(timeout2);
                // return timeout2;

                
            }, [blink]);

        /*  useEffect(() => {
                const options = [
                    "Afrikaans",
                    "Albanian",
                    "Amharic",
                    "Arabic",
                    "Armenian",
                    "Assamese",
                    "Aymara",
                    "Azerbaijani",
                    "Bambara",
                    "Basque",
                    "Belarusian",
                    "Bengali",
                    "Bhojpuri",
                    "Bosnian",
                    "Bulgarian",
                    "Catalan",
                    "Cebuano",
                    "Chichewa",
                    "Simplified Chinese",
                    "Traditional Chinese",
                    "Corsican",
                    "Croatian",
                    "Czech",
                    "Danish",
                    "Dhivehi",
                    "Dogri",
                    "Dutch",
                    "English",
                    "Esperanto",
                    "Estonian",
                    "Ewe",
                    "Filipino",
                    "Finnish",
                    "French",
                    "Frisian",
                    "Galician",
                    "Georgian",
                    "German",
                    "Greek",
                    "Guarani",
                    "Gujarati",
                    "Haitian Creole",
                    "Hausa",
                    "Hawaiian",
                    "Hebrew",
                    "Hindi",
                    "Hmong",
                    "Hungarian",
                    "Icelandic",
                    "Igbo",
                    "Ilocano",
                    "Indonesian",
                    "Irish",
                    "Italian",
                    "Japanese",
                    "Javanese",
                    "Kannada",
                    "Kazakh",
                    "Khmer",
                    "Kinyarwanda",
                    "Konkani",
                    "Korean",
                    "Krio",
                    "Kurmanji Kurdish",
                    "Sorani Kurdish",
                    "Kyrgyz",
                    "Lao",
                    "Latin",
                    "Latvian",
                    "Lingala",
                    "Lithuanian",
                    "Luganda",
                    "Luxembourgish",
                    "Macedonian",
                    "Maithili",
                    "Malagasy",
                    "Malay",
                    "Malayalam",
                    "Maltese",
                    "Maori",
                    "Marathi",
                    "Manipuri",
                    "Mizo",
                    "Mongolian",
                    "Myanmar/Burmese",
                    "Nepali",
                    "Norwegian",
                    "Odia/Oriya",
                    "Oromo",
                    "Pashto",
                    "Persian",
                    "Polish",
                    "Portuguese",
                    "Punjabi",
                    "Quechua",
                    "Romanian",
                    "Russian",
                    "Samoan",
                    "Sanskrit",
                    "Scots Gaelic",
                    "Sepedi",
                    "Serbian",
                    "Sesotho",
                    "Shona",
                    "Sindhi",
                    "Sinhala",
                    "Slovak",
                    "Slovenian",
                    "Somali",
                    "Spanish",
                    "Sundanese",
                    "Swahili",
                    "Swedish",
                    "Tajik",
                    "Tamil",
                    "Tatar",
                    "Telugu",
                    "Thai",
                    "Tigrinya",
                    "Tsonga",
                    "Turkish",
                    "Turkmen",
                    "Twi",
                    "Ukrainian",
                    "Urdu",
                    "Uyghur",
                    "Uzbek",
                    "Vietnamese",
                    "Welsh",
                    "Xhosa",
                    "Yiddish",
                    "Yoruba",
                    "Zulu"
                    ]
                function search() {
                    const div = inputTag.current;
                    console.log(div);
                    searchTag.current.addEventListener('input', (e) => {
                    // var value = e.target.value;
                        let arr = [];
                        let searchWord = searchTag.value.toLowerCase();
                        arr = options.filter(data => {
                            return data.toLowerCase().startsWith(searchWord);
                        //  const res =  data.toLowerCase().startsWith(searchWord);
                        }).map(data => {
                            return ` {isactive && [
                                <div className='dropdown-content' >
                                    <input type='text' onInput={search(e)} placeholder='Search' className='search' ref={searchTag}/>
                                    {options.map(option => ( 
                                    <div className='dropdown-item' onClick={(e) => 
                                        {
                                        setSelectedBame(option)
                                    setIsActive(false)
                                        }}>
                                        ${data}
                                    </div>
                                    ))}
                                    </div>
                                ]}`
                        }).join('');
                        optionss.current.innerHTML = arr;
                    } )
                }
                search();
            }, [])
        */ 


            // function runThis() {
            //         options.filter(item => {
            //             const searchItem = value.toLowerCase();
            //             const optionsLower = item.toLowerCase();
            //             return optionsLower.startsWith(searchItem);
            //         }).map((item) => (
            //             optionss.current.textContent = item
            //         ))
            // }
        // useEffect(() => {
        //     function changeThis() {
        //             setValue(searchTag.current.value)
        //     }
        //     changeThis();
        // })
            // console.log(message)
            const submitData = (e) => {
                setLoading(true)
                e.preventDefault();
                fetch('https://bameio.onrender.com', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({  message, selected }),
                })
                .then((res) => res.json())
                .then((data) => setResponse(data.message))
                setLoading(false)
            }
        return (
            <>
            <div className='body'>
            <div className='mainCont'>
                    <h1>Bame <span>io </span></h1>
                    <p>Let's suggest the perfect baby name for you</p> 
                    <div className='form'>
                    <input type='text' id='input' required ref={inputTag} placeholder={`Type a keyword, e.g: ${text_list[index].substring(0, subIndex)}${blink ? "|" : " "}`} value={message} onChange={(e) => setMessage(e.target.value)}/>
                    <label for=''>Type</label>
                    </div>
                    <div className='dropdown'>
                        <div className='dropdown-btn' onClick={e => {
                            setIsActive(!isactive)
                        }}> {selected} <img src={pic} alt='dropdownImg'/> </div>
                        {isactive && [
                        <div className='dropdown-content' >
                            {/* <input type='text' placeholder='Search' className='search' value={value} ref={searchTag} onInput={runThis} /> */}
                            {options.map(option => ( 
                            <div className='dropdown-item' onClick={(e) => 
                                {
                                setSelected(option)
                            setIsActive(false)
                                }} ref={optionss}>
                                {option}
                            </div>
                            ))}
                            </div>
                        ]}
                    </div>
                    <button className='btn' onClick={submitData}>{isLoading ? 'Loading...' : 'GO'}</button>
                    <div className='getThis'>
                       {response && (
                        <>
            {
                response.substring(response.indexOf('1') + 3).split('2.').map((res) => {
                    return (
            <div className='resCont'><p> {res} </p></div>
            )
                })
            }
            </>
                       )}  
                    </div>
                </div>
                </div>
            </>
        )
        }

        export default Bameio;
